<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="17.132" height="18.737" viewBox="0 0 17.132 18.737">
    <g transform="translate(-630.624 -1230.753)">
      <g transform="translate(-9 653)">
        <line :style="{stroke:color}" class="a" x2="6.126" transform="translate(640.374 581.502)"/>
        <line :style="{stroke:color}" class="a" x1="5.997" transform="translate(643.438 578.503) rotate(90)"/>
      </g>
      <g transform="translate(-541 560.504)">
        <path :style="{stroke:color}" class="b" d="M10,9.151a3.25,3.25,0,0,0,4.9.351l1.95-1.95a3.25,3.25,0,1,0-4.6-4.6L11.137,4.069"
              transform="translate(1170.203 672.995)"/>
        <path :style="{stroke:color}" class="b" d="M9.8,10.3a3.25,3.25,0,0,0-4.9-.351L2.947,11.9a3.25,3.25,0,1,0,4.6,4.6l1.111-1.112"
              transform="translate(1173.005 670.548)"/>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "CooperationPlusIcon",
  props: {
    color: String
  }
}
</script>

<style scoped>
.a, .b {
  fill: none;
  stroke: #fff;
  stroke-linecap: round;
  stroke-width: 1.5px;
}

.b {
  stroke-linejoin: round;
}
</style>
